/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TJoin, TNonEmptyArray, TModule, TTenant } from "../../helpers/utils.graphql";
import { ListCommandResult_Module, CommandResult_Module, EnumerableCommandResult_Module } from "../../helpers/types.graphql";
import { CommandResult, EnumerableCommandResult, ListCommandResult } from "../fragment.graphql";

export type TGlobal = TModule
  | TJoin<"tenant", TTenant>

type TModuleByIdFunctions = { getByID: CommandResult_Module }
export type TModuleByIdQueries = { module: TModuleByIdFunctions };
export const moduleById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query moduleById($id: Guid!) {
    module {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Module")}
`;

type TModuleAllWithPaginationFunctions = { getAllWithPagination: ListCommandResult_Module }
export type TModuleAllWithPaginationQueries = { module: TModuleAllWithPaginationFunctions };
export const moduleAllWithPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query moduleAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    module {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Module")}
`;

type TModuleAllWithSortedPaginationFunctions = { getAllWithSortedPagination: ListCommandResult_Module }
export type TModuleAllWithSortedPaginationQueries = { module: TModuleAllWithSortedPaginationFunctions };
export const moduleAllWithSortedPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query moduleAllWithSortedPagination(
    $page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]
  ) {
    module {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Module")}
`;

type TMyModulesFunction = { getMyModules: EnumerableCommandResult_Module }
export type TMyModuleQueries = { module: TMyModulesFunction };
export const getMyModules = (fields: TNonEmptyArray<TGlobal>) => gql`
  query myModules {
    module {
      getMyModules {
        ...ENUMERABLE_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${EnumerableCommandResult("EnumerableCommandResult_Module")}
`;